import {gql} from '@apollo/client'

// Crea (sin id) o renombra (con id) una etiqueta de documento (Attachments_tag),
// el catálogo usado por Resource Center y los adjuntos de pólizas
export const CREATE_UPDATE_ATTACHMENTS_TAG = gql`
  mutation attachmentsTagCreateUpdate($input: attachments_tag_create_update_mutationInput!) {
    attachmentsTagCreateUpdateMutation(input: $input) {
      attachmentsTag {
        id
        tagName
      }
      errors {
        field
        messages
      }
    }
  }
`
